import { useContext } from 'react';

import { TreeMapStateContext } from './store.js';
import { useStoreSelector } from '../../../core/store/selector.js';
import { TreeMapState } from '../types/state.js';

export const useSelector = <T>(selector: (state: TreeMapState) => T): T =>
  useStoreSelector<T, TreeMapState>(TreeMapStateContext, selector);

export const useSetState = (): typeof setState => {
  const { setState } = useContext(TreeMapStateContext);

  return setState;
};

export const useTreeMapState = () =>
  useSelector((state: TreeMapState) => state);

export const useHighlightedState = () =>
  useSelector((state: TreeMapState) => state.highlightedItems);

export const useTooltipState = () =>
  useSelector((state: TreeMapState) => state.tooltip);

export const useTooltipPinnedState = () =>
  useSelector((state: TreeMapState) => state.tooltip.pinned);

export const useTooltipVisibleState = () =>
  useSelector((state: TreeMapState) => state.tooltip.visible);

export const useGroupsSelectedState = () =>
  useSelector((state: TreeMapState) => state.groupsSelected);

export const useLeafNodesState = () =>
  useSelector((state: TreeMapState) => state.hierarchyLeafNodes);

export const useClusterNodesState = () =>
  useSelector((state: TreeMapState) => state.hierarchyClusterNodes);

export const useOverlayState = () =>
  useSelector((state: TreeMapState) => state.overlay);

export const useToolbarHoverState = () =>
  useSelector((state: TreeMapState) => state.toolbar.isHovered);

export const useColorMap = () =>
  useSelector((state: TreeMapState) => state.colorMap);
